import { useQuery } from '@tanstack/react-query';
import { autoCompleteApi } from '../../../../api/autoCompleteApi';
import { getAutoCompleteResponseSchema } from '../../../../api/types/autoCompleteApiTypes';
import { PAGE } from '../../../../helpers/pages';

const useAutoCompleteValues = (text: string, tag: PAGE) => {
  return useQuery({
    queryKey: ['autoCompleteValues', text],
    queryFn: async () => {
      const { data } = await autoCompleteApi.getAutoCompleteValues(text);
      return getAutoCompleteResponseSchema.parse(data);
    },
    enabled: text.length > 2,
    // 24 hours - autocomplete results for any given search termwon't change that often.
    staleTime: 24 * 60 * 60 * 1000,
    meta: {
      tags: [tag],
      // We don't need to show a toast for this query since the worst-case is they don't see
      // autocomplete suggestions. It's not a critical path.
      noToast: true,
    },
  });
};

export { useAutoCompleteValues };
